const CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_SIZE = 10_000_000;

/** Проверяет известные формат и объём фотографии для переписки */
export const getChatPhotoValidationError = (
    contentType?: string | null,
    size?: number | null,
): string | undefined => {
    if (contentType != null && !CONTENT_TYPES.includes(contentType)) {
        return 'Выберите фотографию JPEG, PNG или WebP';
    }

    if (size != null && (size <= 0 || size > MAX_SIZE)) {
        return 'Фотография должна быть непустой и не больше 10 МБ';
    }

    return undefined;
};
